const en = {
  // Meta
  metaTitle: "FearGreed — Crypto Sentiment Button",
  metaDescription: "The Crypto Fear & Greed Index as a single tactile button. Source-scheduled updates from alternative.me. No accounts, no tracking.",

  // Layout / Nav
  navAbout: "Docs",
  footerPrivacy: "Privacy",
  footerSupport: "Support",
  footerAbout: "Docs",
  footerDataSource: "Data: alternative.me · Not financial advice",

  // App / Button
  loading: "Loading…",
  unableToLoad: "Unable to load index",
  somethingWentWrong: "Something went wrong.",
  tryAgain: "Try again",
  lastUpdated: "Updated {time}",
  updating: "Updating…",
  buttonUpdated: "Updated ✓",
  nowLabel: "{value} ({bucket})",
  sourceLabel: "Source: alternative.me",
  ariaButton: "{value} {bucket} — Fear and Greed Index. Tap for insight.",

  // Ritual
  ritualDisclaimer: "Not financial advice",

  // Info sheet
  infoTitle: "Fear & Greed Index",
  infoDescription: "Crypto market sentiment score (0–100). Volatility, momentum, social, surveys. Source: alternative.me. Not financial advice.",
  infoAttribution: "Data by alternative.me Crypto Fear & Greed Index.",
  info7d: "7-day trend",
  info30d: "30-day trend",
  infoNextUpdate: "Next update",
  infoInterpretTitle: "How to read",
  infoInterpretExtremeFear: "0–24: Extreme Fear. Historically preceded some recoveries.",
  infoInterpretExtremeGreed: "75–100: Extreme Greed. Historically preceded some corrections.",
  infoDisclaimer: "Sentiment indicator only. Past patterns do not predict future results. Do your own research.",
  infoApiTitle: "API",
  infoPulseTitle: "Pulse",
  infoDocsLink: "Full docs & API reference",

  // Navigation
  backToButton: "Back",

  // About / Docs
  aboutTitle: "Docs",
  aboutWhatTitle: "What is FearGreed?",
  aboutWhat: "Displays the Crypto Fear & Greed Index — a daily sentiment score (0–100) computed by alternative.me from volatility, momentum, social media, surveys, dominance, and trends. One signal. No noise.",
  aboutWhyTitle: "Why FearGreed?",
  aboutWhyIntro: "The raw index is a number. FearGreed turns it into a product.",
  aboutWhy1Title: "Ritualized UX",
  aboutWhy1: "One tactile button. No charts, no noise, no dashboards. Tap, read, move on.",
  aboutWhy2Title: "Source-aligned sync",
  aboutWhy2: "Checks for new data via scheduled cron windows aligned with the source's daily update cycle.",
  aboutWhy3Title: "Derived analytics",
  aboutWhy3: "Delta, rolling averages, slope, regime duration, watch labels — computed from raw data, not available from the source.",
  aboutWhy4Title: "Natural language pulse",
  aboutWhy4: "AI-generated daily insight sentence. Contextual, not generic.",
  aboutWhy5Title: "Market tape",
  aboutWhy5: "BTC/ETH 24h changes, market cap, dominance, volume, and a rule-based pressure label. Refreshed every 4 hours.",
  aboutWhy6Title: "Agent-friendly",
  aboutWhy6: "Structured JSON endpoints, llms.txt, OpenAPI spec, and SVG badge. Built for programmatic consumption.",
  aboutSourceTitle: "Data source",
  aboutSource: "Data from alternative.me. The source typically updates once per day around 00:00 UTC. FearGreed checks for new data via scheduled cron windows aligned with this schedule.",
  aboutApiTitle: "API",
  aboutApiDescription: "Public endpoints. CORS-enabled. JSON unless noted. No auth required.",
  aboutApiLatest: "Latest value with derived analytics: delta, averages, distance from neutral.",
  aboutApiHistory: "Last 30 daily values with bucket and color.",
  aboutApiSummary: "Plain text summary. Useful for LLMs and agents.",
  aboutApiBadge: "SVG badge. Embed in READMEs or dashboards.",
  aboutApiContext: "AI-generated daily context with trend hint and all derived analytics. Cached 1h.",
  aboutApiPulse: "Structured analytics: regime, watch label, slope, averages. No AI. Cached 15min.",
  aboutApiTape: "BTC/ETH 24h changes, market cap, dominance, volume, and pressure label. Cached 30min.",
  aboutBadgeTitle: "Badge / Static Embed",
  aboutBadgeDescription: "Embed the current index as an SVG badge:",
  aboutEmbedTitle: "Interactive Embed",
  aboutEmbedDescription: "Embed the full interactive button in any page via iframe. Same tactile feel, no chrome, cached data only.",
  aboutCurlTitle: "Example request",
  aboutJsonExample: "Example response (Latest)",
  aboutLlmsTxtTitle: "llms.txt",
  aboutLlmsTxtDescription: "Machine-readable project summary for LLM agents and crawlers.",
  aboutOpenapiTitle: "OpenAPI",
  aboutOpenapiDescription: "Full API specification in OpenAPI 3.0 format.",
  aboutDisclaimerTitle: "Disclaimer",
  aboutDisclaimer: "Sentiment utility only. Does not predict price movements. Not financial advice. Do your own research.",
  aboutNonAffiliation: "FearGreed is an independent interface. It is not affiliated with or endorsed by alternative.me.",
  staleIndicator: "Offline · cached data",
  infoButton: "More information",
  languageSelector: "Language",
  themeToggle: "Toggle theme",

  // Privacy
  privacyTitle: "Privacy Policy",
  privacyEffectiveDate: "Effective date: March 8, 2026",
  privacySummaryTitle: "Summary",
  privacySummary: "FearGreed does not require login, does not create accounts, and does not collect personal data.",
  privacyDataTitle: "Data collected",
  privacyData: "None. No sign-ups, no tracking cookies, no analytics profiles.",
  privacyTechTitle: "Technical data",
  privacyTech: "Hosting infrastructure may log IP addresses and request timestamps for reliability. Not linked to individual users.",
  privacyThirdPartyTitle: "Third-party services",
  privacyThirdParty: "FearGreed retrieves data from the alternative.me Crypto Fear & Greed Index API. Refer to their privacy policy.",
  privacyAdsTitle: "Advertising",
  privacyAds: "FearGreed does not display ads.",
  privacyChangesTitle: "Changes",
  privacyChanges: "Updates will be posted on this page with a revised effective date.",
  privacyContactTitle: "Contact",
  privacyContact: "Questions? Reach us at",

  // Support
  supportTitle: "Support",
  supportDescription: "For questions or issues, contact us at:",

  // Bucket names (displayed on the button dome)
  bucketExtremeFear: "Extreme Fear",
  bucketFear: "Fear",
  bucketNeutral: "Neutral",
  bucketGreed: "Greed",
  bucketExtremeGreed: "Extreme Greed",

  // Pulse labels
  pulseLabel: "Pulse:",
  regimeSuffix: "{days}d regime",
  watchFearDeepening: "Fear Deepening",
  watchFearStabilizing: "Fear Stabilizing",
  watchNeutralCompression: "Neutral Compression",
  watchGreedAccelerating: "Greed Accelerating",
  watchGreedOverheating: "Greed Overheating",
  watchPossibleReversal: "Possible Reversal",
  watchTrendPersistence: "Trend Persisting",
  watchRecoveryBuilding: "Recovery Building",

  // InfoDrawer data labels
  infoRegimePulse: "Regime & Pulse",
  infoMarketTape: "Market Tape",
  infoPressure: "Pressure",

  // Market pressure labels
  pressureBroadSellOff: "Broad sell-off",
  pressureUnderPressure: "Under pressure",
  pressureBroadRally: "Broad rally",
  pressureRiskAppetite: "Risk appetite improving",
  pressureFlat: "Market flat",
  pressureMixed: "Mixed signals",

  // Countdown
  updateAvailable: "Update available",

  // About — view links
  aboutViewLlmsTxt: "View llms.txt",
  aboutViewOpenapi: "View openapi.json",

  // 404
  notFoundTitle: "Page not found",
  notFoundBack: "Return to Home",

  // Hint
  hintTap: "push me",
} as const;

export default en;
